import React from 'react'
import PropTypes from 'prop-types'
import { observer, inject } from 'mobx-react'

import DividerModel, { NULL as DividerModelNULL } from './model'
import inlineStyles from './inlineStyles'
import EditorModel, {
  NULL as EditorModelNULL,
} from '@client/components/Editor/model'
import {
  ITEM_TYPE_FORM,
  ITEM_TYPE_PAGE,
  ITEM_TYPE_LANDING_PAGE,
  ITEM_TYPE_LANDING_PAGE_SUCCESS,
  ITEM_TYPE_SURVEY,
  ITEM_TYPE_SURVEY_THANK_YOU,
} from '@client/components/Editor/settings'

export const Divider = ({
  model = DividerModelNULL,
  editor = EditorModelNULL,
  serverRender = false,
}) => {
  const globalSettings = editor.settings.values
  const settings = model.settings.values
  const borderHeight = settings.height || globalSettings.divider_height
  const borderStyle = settings.style || globalSettings.divider_style
  const borderColor = settings.color || globalSettings.divider_color
  const dividerBorderStyles = {
    ...inlineStyles.divider_border,
    borderTop: `${borderHeight}px ${borderStyle} ${borderColor}`,
  }

  if (
    editor.kind === ITEM_TYPE_FORM ||
    editor.kind === ITEM_TYPE_PAGE ||
    editor.kind === ITEM_TYPE_LANDING_PAGE ||
    editor.kind === ITEM_TYPE_LANDING_PAGE_SUCCESS ||
    editor.kind === ITEM_TYPE_SURVEY ||
    editor.kind === ITEM_TYPE_SURVEY_THANK_YOU
  ) {
    return (
      <div className={serverRender ? '' : 'divider'} style={inlineStyles.divider}>
        <div
          className={serverRender ? '' : 'divider-border'}
          style={dividerBorderStyles}
          dangerouslySetInnerHTML={{
            __html: '&nbsp;',
          }}
        />
      </div>
    )
  }
  return (
    <table
      cellSpacing="0"
      cellPadding="0"
      width="100%"
      border="0"
      role="presentation"
      className={serverRender ? '' : 'divider'}
      style={inlineStyles.divider}
    >
      <tbody>
        <tr>
          <td
            width="100%"
            style={dividerBorderStyles}
            dangerouslySetInnerHTML={{
              __html: '&nbsp;',
            }}
          />
        </tr>
      </tbody>
    </table>
  )
}

Divider.propTypes = {
  model: PropTypes.instanceOf(DividerModel),
  editor: PropTypes.instanceOf(EditorModel),
  serverRender: PropTypes.bool,
}

export default inject('editor', 'serverRender')(observer(Divider))
